import {Language} from "../interfaces/Language";
import {Region} from "../interfaces/Region";
// @ts-ignore
import {get as getCookie} from "es-cookie";

export class RegionHelper {
	/**
	 * Gets the current site language as defined in the 'language' cookie
	 * @returns {string}
	 */
	static detectLanguage() {
		return getCookie('language') || Language.EN;
	}

	/**
	 * Gets the current site region as defined in the 'region' cookie
	 * @param {string} host
	 * @returns {string}
	 */
	static detectRegion(host?: string) {
		return getCookie('region') ? getCookie('region').toUpperCase() : Region.US;
	}

	/**
	 * Returns whether the current language is the default language for the given region
	 * @returns {boolean}
	 */
	static isDefaultLanguage(): boolean {
		let language = this.detectLanguage();
		let region = this.detectRegion();
		/*if (region === Region.US || region === Region.CA) {
			return language === Language.EN;
		} else if (region === Region.LATAM) {
			return language === Language.ES;
		}*/
		// 10/24/2018 EN is now default for all sites
		return language === Language.EN;

		/*return false;*/
	}

	/**
	 * Returns the localized version of a given URL
	 * @param {string} url
	 * @returns {string}
	 */
	static localizedUrl(url: string): string {
		let language = this.detectLanguage();
		return (RegionHelper.isDefaultLanguage()) ? url : `/${language}${url}`;
	}
}
